/**
 * UIProvider — the single Chakra entry point for the app. Wraps the Chakra system +
 * color mode, and loads the self-hosted fonts. Mounts INSIDE the existing MUI
 * ThemeProvider during the staged migration (both style engines coexist).
 */
import { ChakraProvider } from '@chakra-ui/react';
import type { ReactNode } from 'react';
import './fonts';
import { system } from './system';
import { ColorModeProvider } from './color-mode';

export function UIProvider({ children }: { children: ReactNode }) {
  return (
    <ColorModeProvider>
      <ChakraProvider value={system}>{children}</ChakraProvider>
    </ColorModeProvider>
  );
}
